// API base URL
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8787';

// Helper function to get full API endpoint
export const getApiUrl = (path) => {
  return `${API_URL}${path}`;
};
